import { msg } from '@lingui/macro';

export const TaskboardRoutes = {
  path: 'taskboard',
  lazy: () => import('pages/taskboard'),
  handle: { name: 'Taskboard', category: 'Taskboard', title: msg`Taskboard` },
};
